// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { MetricIn } from './metricIn.zod.ts';

export const fromExtractionCaseAchievementsOneMax = 20000;

export const fromExtractionCaseAliasesOneItemMax = 200;

export const fromExtractionCaseAliasesOneMax = 20;

export const fromExtractionCaseAnonymizedLabelMax = 120;

export const fromExtractionCaseApproachOneMax = 20000;

export const fromExtractionCaseAssetIdsMax = 0;

export const fromExtractionCaseClientNameOneMax = 200;

export const fromExtractionCaseCountryOneMax = 6;

export const fromExtractionCaseMetricsOneMax = 50;

export const fromExtractionCaseObjectiveOneMax = 20000;

export const fromExtractionCaseSituationOneMax = 20000;

export const FromExtractionCase = zod.object({
  "achievements": zod.union([zod.string().max(fromExtractionCaseAchievementsOneMax),zod.null()]).optional(),
  "aliases": zod.union([zod.array(zod.string().max(fromExtractionCaseAliasesOneItemMax)).max(fromExtractionCaseAliasesOneMax),zod.null()]).optional(),
  "anonymized_label": zod.string().min(1).max(fromExtractionCaseAnonymizedLabelMax),
  "approach": zod.union([zod.string().max(fromExtractionCaseApproachOneMax),zod.null()]).optional(),
  "asset_ids": zod.array(zod.uuid()).max(fromExtractionCaseAssetIdsMax).optional(),
  "client_name": zod.union([zod.string().max(fromExtractionCaseClientNameOneMax),zod.null()]).optional(),
  "country": zod.union([zod.string().max(fromExtractionCaseCountryOneMax),zod.null()]).optional(),
  "industry_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "metrics": zod.union([zod.array(MetricIn).max(fromExtractionCaseMetricsOneMax),zod.null()]).optional(),
  "objective": zod.union([zod.string().max(fromExtractionCaseObjectiveOneMax),zod.null()]).optional(),
  "situation": zod.union([zod.string().max(fromExtractionCaseSituationOneMax),zod.null()]).optional(),
  "status": zod.enum(['live', 'pilot', 'pipeline', 'closed']),
  "type": zod.enum(['client', 'benchmark'])
});

export type FromExtractionCase = zod.input<typeof FromExtractionCase>;
export type FromExtractionCaseOutput = zod.output<typeof FromExtractionCase>;
